/**
 * AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPage
 *
 * Page component for AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPage
 * Path: /blog/state-sync-browser-tabs
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostStateSyncBrowserTabsENPostPageView as __AlmadarPostStateSyncBrowserTabsENPostPageView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsENPostPageView';
import { AlmadarPostStateSyncBrowserTabsENPostAnalyticsView as __AlmadarPostStateSyncBrowserTabsENPostAnalyticsView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPageProps {
  // Add any page-level props here
}

export function AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPage(_props: AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostStateSyncBrowserTabsENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostStateSyncBrowserTabsENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostStateSyncBrowserTabsENAlmadarPostStateSyncBrowserTabsENPage;
